import type { Component, Input } from '@builder.io/sdk';

const transitionFields = [
  {
    name: 'direction',
    type: 'string',
    enum: [
      { label: 'Up', value: 'up' },
      { label: 'Down', value: 'down' },
    ],
    required: true,
    defaultValue: 'down',
    helperText: 'Choose the direction of the transition animation.',
  },
] as const satisfies DeepReadonly<Input[]>;

const transitionConfig = {
  name: 'Transition',
  inputs: transitionFields,
} as Component;

export type TransitionFields = GenerateBuilder<typeof transitionFields>;

export default transitionConfig;
